import Template from './../Template'
import InfosRegulation from '../../components/InfosRegulation';

export default function Regulation() {

  return (
    <Template>
      <InfosRegulation />
    </Template>
  );
}
  